export const DifferenceIcon = (): JSX.Element => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4847_42401)">
      <mask
        id="mask0_4847_42401"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <g clipPath="url(#clip1_4847_42401)">
          <path
            d="M23.7958 14.7958C18.938 14.7958 15 10.8578 15 6"
            stroke="#FF00E6"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M15.0001 23.7958C15.0001 18.938 18.9381 15 23.7959 15"
            stroke="#FF00E6"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M6.00012 14.9999C10.8579 14.9999 14.7959 18.9379 14.7959 23.7957"
            stroke="#FF00E6"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M14.7958 5.99987C14.7958 10.8576 10.8578 14.7957 6 14.7957"
            stroke="#FF00E6"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M22.5 22.5L26.25 26.25"
            stroke="#FF00E6"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 7.5L3.75 3.75"
            stroke="#FF00E6"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.5 7.5L26.25 3.75"
            stroke="#FF00E6"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 22.5L3.75 26.25"
            stroke="#FF00E6"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </mask>
      <g mask="url(#mask0_4847_42401)">
        <rect width="30" height="30" fill="#0FBA75" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4847_42401">
        <rect width="30" height="30" fill="white" />
      </clipPath>
      <clipPath id="clip1_4847_42401">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
